import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'ap-badge',
    templateUrl: './badge.component.html',
    styleUrls: ['./badge.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class ApBadgeComponent {}
